let routesWithoutAuth = ['/login', '/requestPasswordReset', '/passwordReset', 'maintenance', '/sso'];

function isAuthRequired(url) {
  let requiresAuth = true;

  routesWithoutAuth.forEach((route) => {
    let regex = new RegExp(route);
    requiresAuth = requiresAuth && !regex.test(url);
  });

  return requiresAuth;
}

function isCurrentUrlLogin(url) {
  return url.indexOf('/login') > -1;
}

let runBlock = ($rootScope, $state, AuthenticationService, roleService, modalLoaderService, Idle, $location, SsoAuthorizationService, config) => {
  $rootScope.$on('$locationChangeStart', (event, newUrl) => {

    if (!isCurrentUrlLogin(newUrl)) {
      Idle.watch();
    }

    if (isCurrentUrlLogin(newUrl)) {
      Idle.unwatch();
    }

    let isUserNotLoggedIn = !AuthenticationService.userIsLoggedIn();
    const isNotSsoLaunch = !SsoAuthorizationService.getSsoLaunch();


    if (isNotSsoLaunch && (isAuthRequired(newUrl) && isUserNotLoggedIn)) {
      event.preventDefault();

      let currentUrl = $location.url();
      $location.url(`/login?redirect=${currentUrl}`);
      
    }
  });

  $rootScope.$on('IdleTimeout', () => {
    //get the value of sso flag from localStorage before we clear it.To make a decision of on the future route.
    const isSsoLaunch = SsoAuthorizationService.getSsoLaunch();
    AuthenticationService.clearCredentials();
    if(isSsoLaunch){
      document.location.href = config.sso.loginURL;
    }else{
      $state.go('timeout');
    } 
  });

  $rootScope.$on('Keepalive', () => {
    AuthenticationService.refreshCredentials();
  });

  $rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState) {
    modalLoaderService.closeAll();
    if (!roleService.isAuthorized(toState.name)) {
      event.preventDefault();

      let defaultStateName = roleService.getRoleFieldValue('defaultStateName');
      let tabName = roleService.getRoleFieldValue('tabName');

      $state.go(defaultStateName,{tabName});

    }

    let isRefreshOnAssignmentsConfirmation = toState.name === 'home.assign.confirmation' && fromState.name.length === 0;
    const isRefreshOnAssignmentsResource = toState.name === 'home.assign.resourceSelector' && fromState.name.length === 0;

    if (isRefreshOnAssignmentsConfirmation || isRefreshOnAssignmentsResource) {
      $location.path('/assign/products').replace();
    }
  });
};


runBlock.$inject = ['$rootScope', '$state', 'AuthenticationService', 'roleService', 'modalLoaderService', 'Idle','$location', 'SsoAuthorizationService', 'config'];

export
default runBlock;



// WEBPACK FOOTER //
// ./app/app.runBlock.js